export default __webpack_public_path__ + "static/media/img-step-b-bg-1.f42cb1f9.jpg";